import { useCallback, useEffect } from 'react';
import { useLocation } from 'react-router-dom';

export const ScrollTop = ({ children }) => {
	const location = useLocation();
    
	const scrollToTop = useCallback(() => {
		const c = document.documentElement.scrollTop || document.body.scrollTop;
		if (c > 0) {
			window.requestAnimationFrame(scrollToTop);
			window.scrollTo(0, c - c / 8);
		}
	}, [])

	useEffect(() => {
		scrollToTop();
	}, [scrollToTop, location]);


	return children;
};